import React from "react"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"

import {useTheme} from "@irati/ui/src/global/useTheme"
import {Wrapper} from "../../../components/Polls/Empty/styled/Feed"
import image from "../../../images/vote-empty.png"

const StyledWrapper = styled(Wrapper)`
  box-shadow: none;
  border: none;
`

const ICON_SIZE = 120

const VoteIcon = styled.img.attrs({
  alt: "trophy",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: image
})`
  margin-bottom: 30px;
`

const EmptyRecognitions: React.FC = () => {
  const theme = useTheme()
  return (
    <StyledWrapper>
      <VoteIcon />
      <Body small marginBottom={4} maxWidth="200px" textAlign="center" color={theme.colors.greys.medium}>
        <FormattedMessage id="recognition.groupCelebration.list.empty" />
      </Body>
    </StyledWrapper>
  )
}
export default EmptyRecognitions
